import * as v from 'valibot';
import { integerInRange } from '../util/valibot';
export const outletKindSchema = v.union([v.literal('onoff'), v.literal('dim'), v.literal('rollershade')]);
export const outletCodeSchema = v.object({
    code: integerInRange(0, 0x3ffffff),
    unit: integerInRange(0, 15),
});
export const outletSchema = v.object({
    id: integerInRange(0, 0xffffffff),
    kind: outletKindSchema,
    title: v.string(),
    codes: v.array(outletCodeSchema),
    comment: v.string(),
});
